module.exports = "<input\n  class=\"{{eventClass}}\"\n  [id]=\"idInput\"\n  [name]=\"name\"\n  [type]=\"type\"\n  [placeholder]=\"placeholder\"\n  [step]=\"step\"\n  [min]=\"min\"\n  [max]=\"max\"\n  [value]=\"value\"\n  (change)=\"onChange($event)\"\n  [attr.pattern]=\"pattern\"\n  (blur)=\"onBlur($event)\"\n  [attr.maxLength]=\"maxlength\"\n  [attr.minLength]=\"minlength\"\n/>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/otp-code-input/otp-code-input.component.html
// module id = ./src/app/components/atoms/otp-code-input/otp-code-input.component.html
// module chunks = main